import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { st, FormControl, Form, FormMessage, Button, Link } from "lib/index";
import AuthLayout from "modules/app/AuthLayout";
import { stateSelector, initializeView, initializeModel, updateModel, submit } from "./index";

@connect(
  (state) => ({
    model: stateSelector(state).form.model,
    valid: stateSelector(state).form.valid,
    submitLoading: stateSelector(state).form.submitLoading,
    errors: stateSelector(state).form.errors,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        initializeView,
        initializeModel,
        updateModel,
        submit,
      },
      dispatch
    )
)
export default class ResetPasswordView extends React.PureComponent {
  componentDidMount() {
    const { next: redirectAfterLogin, token: reset_password_token, email = null } = this.props.location.query;
    this.props.initializeView({ redirectAfterLogin });
    this.props.initializeModel({ reset_password_token, email, password: null, password_confirmation: null });
  }

  handleModelPropChange(prop, value) {
    const { model, updateModel } = this.props;
    updateModel({ ...model, [prop]: value });
  }

  handleSubmit(event) {
    const { submit } = this.props;
    event.preventDefault();
    submit();
  }

  render() {
    const { model, submitLoading, valid, errors } = this.props;

    return (
      <AuthLayout.Container>
        <AuthLayout.Box title={I18n.t("papp.auth.ResetPasswordView.title")}>
          {model && (
            <Form onSubmit={this.handleSubmit.bind(this)} error={!valid} loading={submitLoading}>
              {!!errors.base && <FormMessage error={errors.base} />}

              <FormControl.InputFormGroup
                {...FormControl.addProps(`model.email`, { errors })}
                value={model.email}
                onChange={this.handleModelPropChange.bind(this, "email")}
                label={I18n.humanAttributeName("admin_user", "email")}
                type="email"
                readOnly
              />

              <FormControl.InputFormGroup
                {...FormControl.addProps(`model.password`, { errors })}
                value={model.password}
                onChange={this.handleModelPropChange.bind(this, "password")}
                label={I18n.humanAttributeName("admin_user", "password")}
                type="password"
                required
              />

              <FormControl.InputFormGroup
                {...FormControl.addProps(`model.password_confirmation`, { errors })}
                value={model.password_confirmation}
                onChange={this.handleModelPropChange.bind(this, "password_confirmation")}
                label={I18n.humanAttributeName("admin_user", "password_confirmation")}
                type="password"
                required
              />

              <Button as={Link} basic floated="left" to="/login" content={I18n.t("papp.common.go_back")} />

              <Button type="submit" primary floated="right" content={I18n.t("papp.auth.ResetPasswordView.submit")} />
            </Form>
          )}
        </AuthLayout.Box>
      </AuthLayout.Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/auth/ResetPasswordView/ResetPasswordView.jsx